import { GridCellParams } from '@mui/x-data-grid';
import * as React from 'react';
import Box from '@mui/material/Box';
import { MapUploadStatusBadge } from '../MapUploadStatusBadge';

export const ProcessingStatusCell = (cellValues: GridCellParams) => {
    return (
        <Box
            sx={{
                display: 'flex',
                height: '100%',
                alignItems: 'center',
            }}
        >
            <MapUploadStatusBadge mapUpload={cellValues.row} />
        </Box>
    );
};
